import React from 'react';
import {Table} from '@components';

import utils from '@utils';

import {Props} from './types';
import mappings from '@mappings';

export const makeColumns = (
  props: Props,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
) => [
  {
    Header: () => {
      return (
        <Table.Sort
          value="送信日時"
          accessor="sentDatetime"
          updateCurrent={async (nextSort: string, current: number) => {
            setLoading(true);
            await props.actions.notifications.updateCurrentNotifications({
              page: current,
              sort: nextSort,
              teamId: props.me.teamId,
              disasterType: props.notifications.search.disasterType,
              fromSentDatetime: props.notifications.search.fromSentDatetime,
              toSentDatetime: props.notifications.search.toSentDatetime,
              prefecture: props.notifications.search.prefecture,
            });
            setLoading(false);
          }}
          current={props.notifications.pagination.current}
          currentSort={props.notifications.pagination.sort}
        />
      );
    },
    accessor: 'sentDatetime',
    width: 180,
    Cell: ({cell}: {cell: any; column: any}) => {
      const detail = {
        ...cell.row.original,
        pagination: props.notifications.detail.pagination,
      };

      return (
        <Table.Link
          to={`/disaster-notices/${detail.id}`}
          value={utils.date.format(detail.sentDatetime, 'YYYY/MM/DD HH:mm:ss')}
          detail={detail}
        />
      );
    },
  },
  {
    Header: '送信方法',
    accessor: 'isManual',
    width: 100,
    Cell: ({cell}: {cell: any; column: any}) => {
      return cell.value ? '手動送信' : '自動送信';
    },
  },
  {
    Header: '災害',
    accessor: 'disasterType',
    width: 100,
    Cell: ({cell}: {cell: any; column: any}) => {
      return utils.mappings.getLabel(mappings.disasters, cell.value);
    },
  },
  {
    Header: '地域',
    accessor: 'prefecture',
    width: 100,
    Cell: ({cell}: {cell: any; column: any}) => {
      return utils.mappings.getLabel(mappings.prefectures, cell.value);
    },
  },
  {
    Header: '震度',
    accessor: 'intensity',
    width: 100,
    Cell: ({cell}: {cell: any; column: any}) => {
      return utils.mappings.getLabel(mappings.intensities, cell.value) || '-';
    },
  },
  {
    Header: '送信対象件数',
    accessor: 'sentExecutionCount',
    width: 160,
    Cell: ({cell}: {cell: any; column: any}) => {
      return <b>{cell.value || '0'} 件</b>;
    },
  },
  {
    Header: '送信完了件数',
    accessor: 'sentSuccessCount',
    width: 160,
    Cell: ({cell}: {cell: any; column: any}) => {
      if (
        cell.row.original.sentExecutionCount !==
        cell.row.original.sentSuccessCount
      ) {
        return <b className="c__error_text">{cell.value || '0'} 件</b>;
      }
      return <b>{cell.value || '0'} 件</b>;
    },
  },
  {
    Header: '回答済み件数',
    accessor: 'replyCount',
    width: 160,
    Cell: ({cell}: {cell: any; column: any}) => {
      if (
        cell.row.original.sentExecutionCount !== cell.row.original.replyCount
      ) {
        return <b className="c__error_text">{cell.value || '0'} 件</b>;
      }
      return <b>{cell.value || '0'} 件</b>;
    },
  },
];
